import { useNavigator } from '@repo/toolkit/use-navigator'
import { BuildingTwoIcon, PlusIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API, constructApiUrl } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import useTranslate from '../../../lib/hooks/use-translate'
import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { getTeachingHallColumns } from './utils'

const TeachingHallsListPage = () => {
  const { navigate, navigateWithEvent } = useNavigator()
  const tableRef = useRef<DynamicTableRef<TeachingHall>>(null)
  const { user } = useAuth()
  const { t } = useTranslate()

  const olId = user?.ol?.id

  if (!olId) return null

  return (
    <div>
      <UserNavBar title={'Teaching hall'} icon={BuildingTwoIcon} />
      <div className={'h-4'} />
      <DynamicDataTable<TeachingHall, null>
        ref={tableRef}
        title={'All teaching halls'}
        deleteMessage={{
          attributeName: 'name',
          name: 'teaching hall',
          deleteAll: 'Are you sure you want to delete all the teaching halls?'
        }}
        columns={getTeachingHallColumns(t)}
        selectable
        allowSearchParam
        onRowClick={(teachingHall, event) =>
          navigateWithEvent(
            Paths.TEACHING_HALL_UPDATE_PAGE.replace(':id', teachingHall.id.toString()),
            event
          )
        }
        endpoint={constructApiUrl(API.ols.getTeachingHalls.url, { olId: +olId })}
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            variant: 'primary',
            label: 'Add a new teaching hall',
            fn: () => navigate(Paths.TEACHING_HALL_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default TeachingHallsListPage
